export default __webpack_public_path__ + "static/media/One-Pager-CMab.b0166cf4.pdf";